import { Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocale } from "@/i18n/context";

type PasswordVisibilityToggleProps = {
  visible: boolean;
  onToggle: () => void;
  /** id of the password input this button reveals. */
  controls: string;
};

/**
 * The eye button inside a password field. Icon-only, so its accessible name
 * has to say what pressing it does *now* — screen readers otherwise announce
 * an unlabelled button.
 */
export function PasswordVisibilityToggle({
  visible,
  onToggle,
  controls,
}: PasswordVisibilityToggleProps) {
  const { t } = useLocale();

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
      onClick={onToggle}
      aria-label={visible ? t.auth.hidePassword : t.auth.showPassword}
      aria-pressed={visible}
      aria-controls={controls}
    >
      {visible ? (
        <EyeOff className="h-4 w-4" aria-hidden="true" />
      ) : (
        <Eye className="h-4 w-4" aria-hidden="true" />
      )}
    </Button>
  );
}
